import * as React from 'react';
import Expando from '../../shared/Expando';
import {Inbound, InboundType} from '../shared/InboundInterfaces';
import ActualInboundPackaging from '../../dropoffs/shared/completion-workflow/ActualInboundPackaging';
import InboundService from '../../shared/services/InboundService';
import {InboundApiResponse} from './InboundDeliveryDetails';

interface Props {
  inboundService: InboundService;
  inbound: Inbound;
  lpnReceiveOnly: boolean;
  /** Callback function to update the errors in the parent component. */
  handleApiError: (errors: string[], response: InboundApiResponse) => void;
  /** Callback function to reload inbound details */
  reloadInbound: () => void;
}

const InboundTypeSelectionStep: React.FC<Props> = (props) => {
  const {inbound, inboundService, lpnReceiveOnly} = props;
  const [showExpando, setShowExpando] = React.useState(true);

  const toggleExpando = () => {
    setShowExpando((prev) => !prev);
  };

  const confirmInboundTypeSelection = async (actualInboundPackaging: InboundType) => {
    const response = await inboundService.patchInboundById(inbound.id, {
      actualInboundType: actualInboundPackaging
    });

    if (response?.errors?.length > 0) {
      const errors = [`There was an error confirming inbound #${inbound.id} for receipt`];
      props.handleApiError(errors, response);
    } else {
      props.handleApiError([], undefined);
      props.reloadInbound();
    }
  };

  const inboundTypeSelection = {
    title: 'Select Inbound Type',
    content: (
      <ActualInboundPackaging
        lpnReceiveOnly={lpnReceiveOnly}
        inboundPackagingStringIndicator={true}
        onActualInboundPackagingChange={confirmInboundTypeSelection}
      />
    )
  };

  return (
    <React.Fragment>
      <Expando
        index={2}
        headerIcon={<span className="workflow-step-index">{2}</span>}
        headerText={inboundTypeSelection.title}
        open={showExpando}
        onClick={toggleExpando}
      >
        {inboundTypeSelection.content}
      </Expando>
    </React.Fragment>
  );
};

export default InboundTypeSelectionStep;
